import React from 'react';
import IdentifyGuest from '~/presentation/roles/guest/pages/IdentifyGuest/IdentifyGuest';
import { makeRemoteUpdateAppointmentCompanion } from '~/main/factories/usecases/appointmentCompanion/UpdateAppointmentCompanionFactory';

export const MakeIdentificationFactory: React.FC = () => {
  return (
    <IdentifyGuest getCompanion={makeRemoteUpdateAppointmentCompanion()} />
  );
};
